import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'online-status-modal',
    ];

    static values = {
        // Where the pop-up was opened from, reported in onlineconsult_popup_view.
        source: String,
    };

    openModal(event) {
        if (event) {
            event.preventDefault();
        }

        // The pop-up only exists where the service runs (FR, BE).
        if (this.hasOnlineStatusModalOutlet) {
            this.onlineStatusModalOutlet.openFrom(this.sourceValue);
        }
    }
}
